// src/context/ConnectedClientContext.js
import { createContext, useContext, useState } from "react";

const ConnectedClientContext = createContext();

export const ConnectedClientProvider = ({ children }) => {
  const [connectedClient, setConnectedClient] = useState(null);

  return (
    <ConnectedClientContext.Provider
      value={{ connectedClient, setConnectedClient }}
    >
      {children}
    </ConnectedClientContext.Provider>
  );
};

export const useConnectedClient = () => useContext(ConnectedClientContext);
